// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DownloadApp_app__Ckyo7 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.DownloadApp_inner__1SWMd {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid rgba(243, 243, 243, 0.2);
  padding-bottom: 16px;
  margin-bottom: 16px;
}
.DownloadApp_title__dD8OI {
  color: #fff;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 450;
  line-height: 20px;
}
.DownloadApp_logoItems__Khy4p {
  display: flex;
  justify-content: center;
  align-items: center;
}

.DownloadApp_logoItem__Xt0DH {
  border-radius: 72px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  background: rgba(255, 255, 255, 0.16);
  box-shadow: 0px 94px 26px 0px rgba(0, 0, 0, 0),
    0px 60px 24px 0px rgba(0, 0, 0, 0.01), 0px 34px 20px 0px rgba(0, 0, 0, 0.05),
    0px 15px 15px 0px rgba(0, 0, 0, 0.09), 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
  height: 48px;
  padding: 14px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 156px;
}
.DownloadApp_additionText__hCFgw {
  color: #fff;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 450;
  line-height: 20px;
  padding: 0 12px;
}
@media screen and (min-width: 1200px) {
  .DownloadApp_logoItem__Xt0DH {
    width: 220px;
    height: 48px;
  }
  .DownloadApp_inner__1SWMd {
    margin-bottom: unset;
  }
  .DownloadApp_title__dD8OI,
  .DownloadApp_additionText__hCFgw {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DownloadApp/DownloadApp.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,iDAAiD;EACjD,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC;;6EAE2E;EAC3E,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,oBAAoB;EACtB;EACA;;IAEE,eAAe;EACjB;AACF","sourcesContent":[".app {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.inner {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-bottom: 1px solid rgba(243, 243, 243, 0.2);\n  padding-bottom: 16px;\n  margin-bottom: 16px;\n}\n.title {\n  color: #fff;\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 450;\n  line-height: 20px;\n}\n.logoItems {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.logoItem {\n  border-radius: 72px;\n  border: 1px solid rgba(255, 255, 255, 0.24);\n  background: rgba(255, 255, 255, 0.16);\n  box-shadow: 0px 94px 26px 0px rgba(0, 0, 0, 0),\n    0px 60px 24px 0px rgba(0, 0, 0, 0.01), 0px 34px 20px 0px rgba(0, 0, 0, 0.05),\n    0px 15px 15px 0px rgba(0, 0, 0, 0.09), 0px 4px 8px 0px rgba(0, 0, 0, 0.1);\n  height: 48px;\n  padding: 14px 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 156px;\n}\n.additionText {\n  color: #fff;\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 450;\n  line-height: 20px;\n  padding: 0 12px;\n}\n@media screen and (min-width: 1200px) {\n  .logoItem {\n    width: 220px;\n    height: 48px;\n  }\n  .inner {\n    margin-bottom: unset;\n  }\n  .title,\n  .additionText {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"app": `DownloadApp_app__Ckyo7`,
	"inner": `DownloadApp_inner__1SWMd`,
	"title": `DownloadApp_title__dD8OI`,
	"logoItems": `DownloadApp_logoItems__Khy4p`,
	"logoItem": `DownloadApp_logoItem__Xt0DH`,
	"additionText": `DownloadApp_additionText__hCFgw`
};
export default ___CSS_LOADER_EXPORT___;
